import { SortPayload } from 'react-admin'

export const ListHelper = {
  DEFAULT_SORT: { field: 'name', order: 'ASC' } as SortPayload,
}
